import { ERROR, MENU, MENU_ITEM_PATCH, MENU_ITEM_REMOVE, START, SUCCESS } from '../../types/action-types'

export const menuRequestStart = data => ({
  type: `${MENU}${START}`,
  payload: data,
})

export const menuRequestSuccess = data => ({
  type: `${MENU}${SUCCESS}`,
  payload: data,
})

export const menuRequestError = data => ({
  type: `${MENU}${ERROR}`,
  payload: data,
})

export const menuItemPatch = data => ({
  type: MENU_ITEM_PATCH,
  payload: data,
})

// Убирает блюдо из локального состояния меню сразу после успешного ответа
// (сам запрос уходит из компонента: setMenuAvailable / removeDishFromBusinessLunch).
// { menuId } — скрытие из обычной секции; { menuId, blCategoryId } — из категории БЛ.
export const menuItemRemove = data => ({
  type: MENU_ITEM_REMOVE,
  payload: data,
})
